<div class="alert-page">
  <!-- 👁️ Banner modo visualização -->
  <div *ngIf="watchMode" class="watch-mode-banner">
    <span>👁️ MODO VISUALIZAÇÃO</span>
    <small>Somente observação - Alertas não são confirmados</small>
  </div>

  <app-alert-display
    [event]="event"
    [message]="message"
    [showMessage]="showMessage"
    [alertPosition]="alertPosition"
    [alertVolume]="alertVolume"
    [stopSignal]="stopSignal"
    [voiceRecordingUrl]="voiceRecordingUrl"
    (audioFinished)="onAudioFinished()"
  >
  </app-alert-display>
</div>
